import { render } from "./OverviewHeader.vue?vue&type=template&id=ef014a4c&scoped=true"
import script from "./OverviewHeader.vue?vue&type=script&lang=js"
export * from "./OverviewHeader.vue?vue&type=script&lang=js"

import "./OverviewHeader.vue?vue&type=style&index=0&id=ef014a4c&lang=scss&scoped=true"
import "./OverviewHeader.vue?vue&type=style&index=1&id=ef014a4c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef014a4c"]])

export default __exports__